// this function is done uniquely to give a particular dateFormat to material-ui components

import dateFormat from 'dateformat'
import * as c from '../../../constants'

const formatDateForMatUi = value => dateFormat(value, c.dateDMY)

export default formatDateForMatUi
